import { CartPage } from "../blocks/Cart/Page/CartPage";

export const DealerCartPage = CartPage;
